import { createSlice } from "@reduxjs/toolkit";

// Helper function to get initial theme
const getInitialTheme = () => {
  if (typeof window !== 'undefined') {
    const savedTheme = localStorage.getItem("dataTheme");
    if (savedTheme) return savedTheme;
    return window.matchMedia('(prefers-color-scheme: dark)').matches
      ? 'dark-mode'
      : 'light-mode';
  }
  return 'light-mode';
};

const initialState = {
  dataTheme: getInitialTheme(),
};

const themeSettingSlice = createSlice({
  name: "themeSetting",
  initialState,
  reducers: {
    setDataTheme: (state, action) => {
      const theme = action.payload;
      const html = document.documentElement;

      // Remove all theme classes
      html.classList.remove('light-mode', 'dark-mode');

      // Add the selected theme class
      html.classList.add(theme);

      // Set data-theme attribute
      html.setAttribute('data-theme', theme === 'dark-mode' ? 'dark' : 'light');

      // Update state and localStorage
      state.dataTheme = theme;
      localStorage.setItem("dataTheme", theme);
    },
  },
});

export const { setDataTheme } = themeSettingSlice.actions;
export default themeSettingSlice.reducer;